import styled from "styled-components";

const Page = styled.div`
    width: 100%;
    background: #111315;
    color: #f5f5f5;
`;

const LandingSection = styled.section`
    width: 100%;
    min-height: 100vh;

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Hero = styled.div`
    width: 80%;
    max-width: 1000px;
    text-align: center;
`;

const Name = styled.h1`
    font-size: 3rem;
    margin-bottom: 16px;
    font-family: "Cormorant Garamond", serif;
    font-weight: 800;
    letter-spacing: 0.5px;
`;

const Description = styled.p`
    font-size: 1.1rem;
    line-height: 1.8;
    color: #b8b8b8;
    max-width: 750px;
    margin: 0 auto;
`;

const ProjectsSection = styled.div`
    width: 80%;
    max-width: 1100px;
    margin-top: 70px;
    display: flex;
    gap: 30px;

    @media (max-width: 900px) {
        flex-direction: column;
        margin-top: 50px;
    }
`;

const ProjectCard = styled.div`
    flex: 1;
    padding: 32px;
    background: #111315;
    border: 1px solid #2b2f35;
    cursor: pointer;
    transition: all 0.2s ease;

    &:hover {
        transform: translateY(-4px);
        border-color: #c9a86a;
        box-shadow: 0 12px 30px rgba(0, 0, 0, 0.35);
    }
`;

const ProjectTitle = styled.h2`
    margin-bottom: 12px;
    color: #ffffff;
    font-size: 1.4rem;
    text-align: center;
`;

const ProjectDescription = styled.p`
    color: #9ea4ad;
    line-height: 1.7;
`;

function StartPage() {
    const openYoutube = () => {
        window.open(
            "https://www.youtube.com/@lorenz-frank",
            "_blank"
        );
    };

    const openIuno = () => {
        window.open(
            "https://www.iunoni.com/",
            "_blank"
        );
    };

    return (
        <Page>
            <LandingSection>
                <Hero>
                    <Name>Hey, I'm Lorenz.</Name>

                    <Description>
                        I'm a history enthusiast and hobby developer. I want to
                        figure out how the heck we ended up in this modern
                        world. Check out the projects I'm currently
                        working on:
                    </Description>
                </Hero>

                <ProjectsSection>
                    <ProjectCard onClick={openIuno}>
                        <ProjectTitle>iunoni.com</ProjectTitle>

                        <ProjectDescription>
                            A Latin learning platform with a built-in
                            dictionary, lessons that progress in difficulty, and
                            a smart vocabulary trainer that recognizes the words
                            you struggle with.
                        </ProjectDescription>
                    </ProjectCard>

                    <ProjectCard onClick={openYoutube}>
                        <ProjectTitle>YouTube</ProjectTitle>

                        <ProjectDescription>
                            Videos exploring history, from ancient civilizations
                            to major events that shaped the modern world. A
                            place for historical storytelling, analysis, and
                            discussion.
                        </ProjectDescription>
                    </ProjectCard>
                </ProjectsSection>
            </LandingSection>
        </Page>
    );
}

export default StartPage;